<template>
  <div class="page-detail">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}`">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="`${$subsitePrefix}/council`"
          >理事会信息</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ metaData.name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content detail-content">
        <div class="left">
          <side-nav :data="councilInfoList"></side-nav>
        </div>
        <div class="right">
          <column-header2 :data="metaData"></column-header2>
          <div class="content" v-html="fieldValue"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideNav from "_c/SideNav";
import ColumnHeader from "_c/ColumnHeader2";
import { mapState } from "vuex";
export default {
  data() {
    return {
      fieldValue: "",
      metaData: {
        name: ""
      }
    };
  },
  computed: {
    ...mapState("college", ["councilInfoList", "collegeData"])
  },
  created() {
    this.init();
  },
  components: {
    [SideNav.name]: SideNav,
    [ColumnHeader.name]: ColumnHeader
  },
  methods: {
    init() {
      if (!this.collegeData.council) {
        this.$router.push(this.$subsitePrefix);
      }
      let fieldName = this.$route.params.id;
      this.fieldValue = this.collegeData.council[fieldName];
      this.metaData.name = this.councilInfoList.find(
        p => p.id === fieldName
      ).title;
    }
  },
  watch: {
    $route() {
      this.init();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-detail {
  background: #f6f6f9;
  padding-bottom: 40px;
  .detail-content {
    padding: 16px 0 40px 0;
    display: flex;
    justify-content: space-between;
    ::v-deep .comp-column-header {
      padding: 16px 0 32px 0;
    }
    .left {
      width: 200px;
      margin-right: 24px;
    }
    .right {
      flex: 1;
      ::v-deep .content {
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        line-height: 1.8em;
        margin-right: 72px;
        p {
          text-indent: 2em;
          padding-bottom: 0.4em;
        }
        h6,
        h5,
        h4,
        h3,
        h2,
        h1 {
          padding-bottom: 0.8em;
        }
      }
    }
  }
}
</style>
